/** Tutorial guidato dell'elenco Tag. */
const at = name => `[data-tour-scope="tags-list"] [data-tour="${name}"]`;
const ADD = '[data-tour="add-tag"]';
const EDIT = '[data-tour="row-edit"]';

const visible = selector => {
	const element = document.querySelector(selector);
	return !!element && element.getClientRects().length > 0;
};

const pause = () => new Promise(resolve => setTimeout(resolve, 0));

async function openMenu(activator, probe) {
	await pause();
	if (!visible(probe)) document.querySelector(activator)?.click();
}

async function closeMenus() {
	for (const [activator, probe] of [[at('add'), ADD], [at('row-menu'), EDIT]]) {
		if (visible(probe)) document.querySelector(activator)?.click();
	}
}

export async function stopTagsListTour() {
	await closeMenus();
}

export function createTagsListTourSteps() {
	return [
		{ body: "I tag sono etichette trasversali assegnate ai prodotti: servono per raggrupparli e filtrarli senza modificare categorie o varianti.", key: 'intro', placement: 'bottom', target: at('tutorial'), title: 'Gestire i tag' },
		{ body: "La ricerca filtra l'elenco per nome. Premi Invio o la lente per applicarla.", key: 'search', placement: 'bottom', target: at('search'), title: 'Cercare un tag' },
		{ body: "La tabella mostra nome nella lingua predefinita, numero di prodotti collegati e data di creazione. Le traduzioni nelle altre lingue si modificano dalla scheda del tag, che si apre dai tre puntini.", key: 'table', placement: 'top', target: at('table'), title: 'Leggere l’elenco' },
		{ body: "Una bandierina per ogni lingua del negozio: a colori dove il nome del tag e' scritto, in grigio dove manca. Se scrivi il nome in una sola lingua, al salvataggio vale anche per le altre lasciate vuote.", key: 'langs', placement: 'bottom', target: at('langs'), timeout: 250, title: 'Le lingue del tag' },
		{ body: "Il piu' apre la pagina del nuovo tag, che ha un tutorial tutto suo.", before: () => openMenu(at('add'), ADD), key: 'add', placement: 'left', target: ADD, title: 'Aggiungere un tag' },
		{ body: "I tre pallini permettono di modificare o eliminare il singolo tag. La modifica apre la pagina del tag, con un tutorial dedicato.", before: () => openMenu(at('row-menu'), EDIT), key: 'row-menu', placement: 'right', target: EDIT, timeout: 250, title: 'Menu del tag' },
	];
}
